<template>
    <table class="table table-hover">
        <thead>
        <tr>
            <th>Codice Paziente</th>
          <th>Iniziali</th>
          <th>Data di nascita</th>
            <th>Data di inserimento</th>
          <th v-if="isFollowUpTable">Follow up (n/tot)</th>
          <th>Note</th>
            <th></th>
        </tr>
        </thead>
        <tbody id="entry-list">
        <EntryRow
                :entry="entry"
                v-for="entry in entries"
                v-bind:key="entry.id"
              :is-follow-up-table="isFollowUpTable"
                @open-entry="$emit('open-entry', entry.id)"
                @open-delete="$emit('open-delete', entry.id)"
                :delete-permission="deletePermission"
        ></EntryRow>
        </tbody>
    </table>
</template>

<script>
    import EntryRow from "./EntryRow";
    export default {
        name: "EntryTable",
        components: { EntryRow },
        props: {
            entries: {
                type: Array,
                required: true
            },
          isFollowUpTable: {
                type: Boolean,
                default: false
            },
            deletePermission: Boolean
        }
    };


</script>
